import type { HTMLAttributes, Ref } from 'react'

const cx = (...classes: (string | undefined | false | null)[]) => classes.filter(Boolean).join(' ')

interface DivProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
}

const SigninWrapperBase = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('grid gap-5 max-w-[320px] shrink-0 rounded-[3px] bg-white', className)}
    {...rest}
  >
    {children}
  </div>
)

const SigninHeader = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('gap-1 text-[#212121] font-roboto h-auto', className)}
    {...rest}
  >
    {children}
  </div>
)

const SigninHeaderTitle = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('font-semibold text-xl', className)}
    {...rest}
  >
    {children}
  </div>
)

const SigninHeaderDescription = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('font-normal text-xs', className)}
    {...rest}
  >
    {children}
  </div>
)

const SigninBody = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('grid gap-2', className)}
    {...rest}
  >
    {children}
  </div>
)

const SigninFooter = ({ ref, className, children, ...rest }: DivProps) => (
  <div
    ref={ref}
    className={cx('mt-2.5 grid', className)}
    {...rest}
  >
    {children}
  </div>
)

export const SigninWrapper = Object.assign(SigninWrapperBase, {
  Header: SigninHeader,
  HeaderTitle: SigninHeaderTitle,
  HeaderDescription: SigninHeaderDescription,
  Body: SigninBody,
  Footer: SigninFooter,
})
